import React, {
    useEffect,
    useState,
} from "react";

import {
    Stack,
    Select,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";


const EditQuestionDrawer = ({
    isOpen,
    onClose,
    question,
    onSubmit,
}) => {

    const [
        formData,
        setFormData,
    ] = useState({
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_answer: "",
        display_order: 1,
        active: true,
    });


    useEffect(() => {

        if (question) {

            setFormData({
                question:
                    question.question || "",

                option_a:
                    question.option_a || "",

                option_b:
                    question.option_b || "",

                option_c:
                    question.option_c || "",

                option_d:
                    question.option_d || "",

                correct_answer:
                    question.correct_answer || "",

                display_order:
                    question.display_order ?? 1,

                active:
                    question.active ?? true,
            });

        }

    }, [question]);


    const handleChange = (e) => {

        const {
            name,
            value,
        } = e.target;

        setFormData(
            (prev) => ({
                ...prev,

                [name]:
                    name === "display_order"
                        ? Number(value)
                        : value,
            })
        );
    };


    return (

        <ReusableDrawer

            isOpen={isOpen}

            onClose={onClose}

            headerContent={
                <h2>
                    Edit Question
                </h2>
            }

            bodyContent={

                <Stack spacing={4}>

                    <ReusableInput
                        label="Question"
                        name="question"
                        value={
                            formData.question
                        }
                        onChange={
                            handleChange
                        }
                        type="textarea"
                        isRequired
                    />

                    <ReusableInput
                        label="Option A"
                        name="option_a"
                        value={
                            formData.option_a
                        }
                        onChange={
                            handleChange
                        }
                        isRequired
                    />

                    <ReusableInput
                        label="Option B"
                        name="option_b"
                        value={
                            formData.option_b
                        }
                        onChange={
                            handleChange
                        }
                        isRequired
                    />

                    <ReusableInput
                        label="Option C"
                        name="option_c"
                        value={
                            formData.option_c
                        }
                        onChange={
                            handleChange
                        }
                        isRequired
                    />

                    <ReusableInput
                        label="Option D"
                        name="option_d"
                        value={
                            formData.option_d
                        }
                        onChange={
                            handleChange
                        }
                        isRequired
                    />

                    <Select
                        name="correct_answer"
                        value={
                            formData.correct_answer
                        }
                        onChange={
                            handleChange
                        }
                    >

                        <option value="A">
                            Option A
                        </option>

                        <option value="B">
                            Option B
                        </option>

                        <option value="C">
                            Option C
                        </option>

                        <option value="D">
                            Option D
                        </option>

                    </Select>

                    <ReusableInput
                        label="Display Order"
                        name="display_order"
                        type="number"
                        value={
                            formData.display_order
                        }
                        onChange={
                            handleChange
                        }
                    />

                </Stack>
            }

            footerContent={

                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={4}
                >

                    <GradientButton
                        width="100px"
                        height="40px"
                        onClick={onClose}
                    >
                        Cancel
                    </GradientButton>

                    <GradientButton
                        width="120px"
                        height="40px"
                        onClick={() =>
                            onSubmit(
                                question.question_id,
                                formData
                            )
                        }
                    >
                        Save
                    </GradientButton>

                </Stack>
            }
        />
    );
};


export default EditQuestionDrawer;